// eslint-disable-next-line no-restricted-imports
import { useTheme } from '@emotion/react';
import { useCartDrawer } from '@iheartjane/cart';
import { Box } from '@iheartjane/reefer';
import type { AppMode } from '@iheartjane/types';
import { useNavigate } from 'react-router';

import { Modal } from '@jane/monolith/components/modal';
import { useCustomerDispatch } from '@jane/monolith/customer/dispatch';
import { replaceCart, selectCart } from '@jane/monolith/customer/redux/cart';
import { closeModal } from '@jane/monolith/customer/redux/modal';
import { useCustomerSelector } from '@jane/monolith/customer/selectors';
import { useMoengage } from '@jane/shared-ecomm/tracking';
import { useEcommApp } from '@jane/shared/providers';
import { monolithPaths as paths } from '@jane/shared/util';

import { ReplaceCartContents } from './contents';

export const ReplaceCart = () => {
  const { moeTrack } = useMoengage();
  const theme = useTheme();
  const dispatch = useCustomerDispatch();
  const navigate = useNavigate();
  const { appMode } = useEcommApp();
  const drawer = useCartDrawer();
  const { replacementCart } = useCustomerSelector(selectCart);

  const goToNextPath = (appMode: AppMode) => {
    if (appMode === 'default') {
      return dispatch(closeModal());
    }

    return navigate(paths.embeddedMenu());
  };

  const onReplaceCart = () => {
    if (!replacementCart) {
      return;
    }
    dispatch(replaceCart(replacementCart, moeTrack, drawer));
    goToNextPath(appMode);
  };

  if (appMode === 'default') {
    return (
      <div>
        <Modal
          contentLabel="Clear bag"
          // eslint-disable-next-line react/forbid-component-props -- legacy emotion
          css={{ borderRadius: theme?.borderRadius.sm }}
          width="small"
        >
          {(closeModal: () => void) => (
            <ReplaceCartContents
              onCancel={closeModal}
              onReplaceCart={onReplaceCart}
            />
          )}
        </Modal>
      </div>
    );
  }

  return (
    <Box mx="auto" maxWidth={360} pt={24}>
      <ReplaceCartContents
        onCancel={() => replacementCart && goToNextPath(appMode)}
        onReplaceCart={onReplaceCart}
      />
    </Box>
  );
};
